import useControlledState from '@quid/react-use-controlled-state';
import RcTooltip from 'rc-tooltip';
import React, { useRef } from 'react';
import { OverflowContext } from './OverflowContext';
import { OverflowTrigger } from './OverflowTrigger';
import { Paper } from './Paper';
import { tooltipProps } from './Tooltip.props';
import { Global } from './Tooltip.styles';
import './tooltip.theme';

export const Tooltip = ({ title, visible, onVisibleChange, maxWidth, children, ...rest }) => {
  const [visibleControlled, onVisibleChangeControlled] = useControlledState(visible === undefined ? false : undefined, visible, onVisibleChange);
  const { current: overflowTriggers } = useRef(new Set());

  const handleVisibleChange = (value) => {
    if (value) {
      const noOverflowTriggers = overflowTriggers.size === 0;
      const hasOverflowTriggerCut = [...overflowTriggers].some((isOverflowActive) => isOverflowActive());
      if (noOverflowTriggers || hasOverflowTriggerCut) {
        onVisibleChangeControlled(value);
      }
    } else {
      onVisibleChangeControlled(false);
    }
  };

  return (
    <>
      <Global id="global-tooltip-styles" />
      <OverflowContext.Provider value={overflowTriggers}>
        <RcTooltip
          visible={title && visibleControlled}
          onVisibleChange={handleVisibleChange}
          mouseEnterDelay={0.3}
          {...rest}
          overlay={<Paper maxWidth={maxWidth}>{title}</Paper>}
        >
          {children}
        </RcTooltip>
      </OverflowContext.Provider>
    </>
  );
};

Tooltip.props = tooltipProps;
Tooltip.defaultProps = {
  animation: 'zoom',
  placement: 'bottom',
};

Tooltip.OverflowTrigger = OverflowTrigger;
